import React from "react";
import { useTranslation } from "react-i18next";

export default function NotFound() {
    const { t } = useTranslation();

    return (
        <div className="min-h-screen bg-white text-brandBlue flex flex-col items-center justify-center px-4 md:px-16 lg:px-24">
            <div className="text-center">
                <h1 className="font-superWonder text-8xl md:text-[12rem] lg:text-[16rem] leading-none text-brandBlue">
                    404
                </h1>
                <h2 className="font-superWonder text-3xl md:text-5xl lg:text-6xl text-brandBlue mt-4">
                    {t("notFound.title")}
                </h2>
                <p className="font-poppins text-lg md:text-xl text-brandGrey mt-6 max-w-md mx-auto">
                    {t("notFound.message")}
                </p>
                <a
                    href="/"
                    className="inline-block mt-8 px-8 py-4 bg-brandBlue text-white font-poppins font-bold rounded-lg shadow-lg hover:bg-opacity-90 transition-all duration-300"
                >
                    {t("notFound.backHome")}
                </a>
            </div>
        </div>
    );
}
